import { bridge } from '../../../bridge';
import { getWebBaseURL } from '../../../getWebBaseURL';
import { appendParams, buildUrl, finalizeUrl } from '../../utils';

export const moveToScreens = (screenName: string) => {
  const link = buildUrl('ably://screens');
  appendParams(link, 'screen_name', screenName);
  bridge.openDeeplink(finalizeUrl(link), {
    webCallback: async () => {
      const baseURL = await getWebBaseURL();
      location.href = `${baseURL}/screens/?screen_name=${screenName}`;
    },
  });
};
